var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInventory2Blue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1358_7802",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1358_7802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 18.3334C3.70817 18.3334 3.31581 18.1702 2.98942 17.8438C2.66303 17.5174 2.49984 17.1251 2.49984 16.6667V7.27092C2.24984 7.11814 2.04845 6.92022 1.89567 6.67717C1.74289 6.43411 1.6665 6.15286 1.6665 5.83342V3.33341C1.6665 2.87508 1.8297 2.48272 2.15609 2.15633C2.48248 1.82994 2.87484 1.66675 3.33317 1.66675H16.6665C17.1248 1.66675 17.5172 1.82994 17.8436 2.15633C18.17 2.48272 18.3332 2.87508 18.3332 3.33341V5.83342C18.3332 6.15286 18.2568 6.43411 18.104 6.67717C17.9512 6.92022 17.7498 7.11814 17.4998 7.27092V16.6667C17.4998 17.1251 17.3366 17.5174 17.0103 17.8438C16.6839 18.1702 16.2915 18.3334 15.8332 18.3334H4.1665ZM3.33317 5.83342H16.6665V3.33341H3.33317V5.83342ZM8.33317 11.6667H11.6665C11.9026 11.6667 12.1005 11.5869 12.2603 11.4272C12.42 11.2674 12.4998 11.0695 12.4998 10.8334C12.4998 10.5973 12.42 10.3994 12.2603 10.2397C12.1005 10.0799 11.9026 10.0001 11.6665 10.0001H8.33317C8.09706 10.0001 7.89914 10.0799 7.73942 10.2397C7.5797 10.3994 7.49984 10.5973 7.49984 10.8334C7.49984 11.0695 7.5797 11.2674 7.73942 11.4272C7.89914 11.5869 8.09706 11.6667 8.33317 11.6667Z",
    fill: "#1B4B86"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInventory2Blue);
export default __webpack_public_path__ + "static/media/icon_inventory_2_blue.7b28233f27960a1d9a9e67a176c0d56d.svg";
export { ForwardRef as ReactComponent };